<template>
  <SearchFile
    label="Recherchez votre maitre de stage (Nom, prénom, numéro de permis)"
    selectYourElementText="Sélectionnez votre maitre de stage dans la liste"
    elementNonRepertorieText="Mon maitre de stage n'est pas répertorié"
    noResultsFoundText="Aucun pharmacien trouvé, utilisez un autre mot-clé"
    maxWidth="600"
    :searchUrl="(keyword) => `/contacts/search?keyword=${keyword}`"
    @elementSelected="pharmacienSelected"
    :fillKeywordAfterSelect="(element) => `${element.fullName} - ${element.licenseNumber}`"
    :rules="rules"
  >
    <template v-slot:cardContent="{ element }">
      <h3>{{ element.fullName }}</h3>
      <p class="mb-0 caption">{{ element.licenseNumber }}</p>
    </template>
  </SearchFile>
</template>

<script>
import SearchFile from "@/components/Common/SearchFile"
export default {
  components: { SearchFile },
  props: { rules: Array },
  methods: {
    pharmacienSelected(pharmacien) {
      this.$emit("pharmacien-selected", { ...pharmacien })
    }
  }
}
</script>

<style>
</style>